<template>
    <div
        class="f-formInput"
    >
        <input
            v-bind="$attrs"
            class="k-c-input f-formInput__input"
            :class="{
                [`k-c-input--${status}`]: status,
                [`has-status-${status}`]: status,
                'f-formInput__input--hasEndIcon': showValidIcon,
            }"
            :value="modelValue"
            @input="onInput"
            @change="onChange"
        >
        <!-- This needs to be replaced with global styles classes, further explanation in comment #1 -->
        <div
            v-if="showValidIcon"
            class="f-formInput__endIcon f-formInput__endIcon--visible"
        >
            <AppIcon
                name="check"
                size="l"
            />
        </div>
    </div>
</template>

<script setup>
import AppIcon from '../app/AppIcon.vue';

const props = defineProps({
    modelValue: {
        type: [
            String,
            Number,
        ],
    },
    modelModifiers: {
        default: () => ({}),
        type: Object,
    },
    status: {
        type: String,
    },
    showValidIcon: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue']);

const onChange = event => (props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);
const onInput = event => (!props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);
</script>

<script>
export default {
    inheritAttrs: false,
};
</script>

<style lang="scss">
@import '~@karriereat/global-styles/scss/settings/spacing';

.f-formInput {
    position: relative;

    &__input {
        &--hasEndIcon {
            padding-right: $k-spacing--3xl;
        }
    }

    // #1 After KALF-346 is done, this should be implemented as 'k-c-input__endIcon' in global styles.
    // For now this part is a copy from 'k-c-inputGroup__endIcon, where this logic already exists'.
    // NOTE: width, height and margin are different so this need to be adjusted in the global styles as well
    &__endIcon {
        position: absolute;
        top: 0;
        right: 0;
        display: none;
        margin-top: $k-spacing--m;
        margin-right: $k-spacing--l;
        padding: 0;
        width: $k-spacing--xl;
        height: $k-spacing--xl;
        outline: none;
        border: none;
        border-radius: var(--k-rounded-sm);
        appearance: none;
        background: transparent;
        color: var(--k-gray-500);

        &--visible {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>
